import EcoBundleEarlyBird from 'eco-design/sections/eco-bundle-early-bird';
import { EcoBundleEarlyBirdItemProps } from 'eco-design/sections/eco-bundle-early-bird/type';
import { useRouter } from 'next/router';
import useWssEarlyBird from '../../../../../compCommon/hooks/UseWssEarlyBird';
import styles from './index.module.scss';
import { activityIdMap } from './config';
import { useLang } from '@/i18n';
import { PRODUCT_OBJ } from './product_list';

export default function GS_Bundles() {
    const { t } = useLang('theProduct.bundles');
    const { locale = 'us' } = useRouter();
    const bundles = [
        {
            desc: [t('item1_desc1')],
        },
        {
            desc: [t('item2_desc1'), t('item2_desc2')],
        },
        {
            desc: [t('item3_desc1'), t('item3_desc2'), t('item3_desc3')],
        },
        {
            desc: locale === 'us' ? [t('item4_desc1'), t('item4_desc2'), t('item4_desc3')] : [t('item4_desc1'), t('item4_desc2')],
        },
        {
            desc: locale === 'us' ? [t('item5_desc1'), t('item5_desc2'), t('item5_desc3')] : [t('item5_desc1'), t('item5_desc2')],
        },
        {
            desc: [t('item6_desc1'), t('item6_desc2'), t('item6_desc3')],
        },
    ].map((item, idx) => ({ ...item, ids: PRODUCT_OBJ[locale as 'us'][idx] })) as EcoBundleEarlyBirdItemProps[];

    const { items, onCountdownEnd } = useWssEarlyBird(activityIdMap[locale as 'us'] || activityIdMap.us, bundles) || bundles;

    return (
        <div className={styles.bundles}>
            <EcoBundleEarlyBird items={items} onCountdownEnd={onCountdownEnd} />
        </div>
    );
}
